import { useEffect } from 'react';

export const SITE_NAME = 'Suraj Giri';
export const SITE_URL = 'https://www.girisuraj.com.np';

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.rel ? 'link' : 'meta');
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => {
    if (v == null) el.removeAttribute(k);
    else el.setAttribute(k, v);
  });
  return el;
};

/**
 * Per-route document head. The old site shipped one static <title> and
 * four meta tags total for seven routes, so every page was bookmarked,
 * announced, and link-previewed identically.
 *
 * Deliberately not react-helmet-async: this is ~30 lines and adds no
 * runtime dependency.
 */
export const usePageHead = ({ title, description, path, image, type = 'website' }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    const url = `${SITE_URL}${path || ''}`;
    const ogImage = `${SITE_URL}${image || '/og-default.png'}`;

    document.title = fullTitle;

    if (description) {
      upsert('meta[name="description"]', { name: 'description', content: description });
    }
    upsert('link[rel="canonical"]', { rel: 'canonical', href: url });

    upsert('meta[property="og:title"]',       { property: 'og:title', content: fullTitle });
    upsert('meta[property="og:type"]',        { property: 'og:type', content: type });
    upsert('meta[property="og:url"]',         { property: 'og:url', content: url });
    upsert('meta[property="og:site_name"]',   { property: 'og:site_name', content: SITE_NAME });
    upsert('meta[property="og:image"]',       { property: 'og:image', content: ogImage });
    if (description) {
      upsert('meta[property="og:description"]', { property: 'og:description', content: description });
    }

    upsert('meta[name="twitter:card"]',  { name: 'twitter:card', content: 'summary_large_image' });
    upsert('meta[name="twitter:title"]', { name: 'twitter:title', content: fullTitle });
    if (description) {
      upsert('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    }
    upsert('meta[name="twitter:image"]', { name: 'twitter:image', content: ogImage });
  }, [title, description, path, image, type]);
};

export default usePageHead;
